import { ITemplate } from '@ViewModels';
import { StyleDeclarationValue, css } from 'aphrodite';
import * as React from 'react';
import { v4 as uuidgen } from 'uuid';
import { isIE11 } from '../../../models/Browser';
import { baseStyleSheet } from '../../styles/styles';
import { HtmlNewsletterPreview } from '../HtmlNewsletterPreview';
import { TextInput } from '../TextInput';
import { EditItemPenIcon } from '../svgs/icons/EditItemPenIcon';
import { styleSheet } from './styles';

interface IHtmlNewsletterCampaignComposerProps {
	className?: string;
	hideSubject?: boolean;
	isForAutomation?: boolean;
	onEditEmailClicked?(e: React.MouseEvent<HTMLElement>): void;
	onSubjectChanged?(subject: string): void;
	readonly?: boolean;
	styles?: StyleDeclarationValue[];
	subject?: string;
	template: ITemplate;
}

const HtmlNewsletterCampaignComposer: React.FC<IHtmlNewsletterCampaignComposerProps> = props => {
	const {
		className,
		styles,
		onSubjectChanged,
		subject,
		template,
		onEditEmailClicked,
		hideSubject,
		isForAutomation,
		readonly,
	} = props;
	const inputGuid = React.useRef(uuidgen()).current;
	const previewerStyles = React.useRef<StyleDeclarationValue[]>([
		styleSheet.htmlNewsletterComposerContent,

		hideSubject ? styleSheet.htmlNewsletterComposerContentWithoutSubject : null,
	]);
	const [internalSubject, setInternalSubject] = React.useState('');
	const onChange = React.useCallback((e: React.ChangeEvent<HTMLInputElement>) => {
		const value = e.target.value;
		if (!!onSubjectChanged && (subject !== null || subject !== undefined)) {
			onSubjectChanged(value);
		} else {
			setInternalSubject(value);
		}
		// eslint-disable-next-line react-hooks/exhaustive-deps
	}, []);

	const label = (
		<span>
			Subject:
			<span className={css(baseStyleSheet.required)}>*</span>
			&nbsp;
		</span>
	);

	return (
		<div
			className={`${css(isForAutomation ? styleSheet.htmlNewsletterComposerContentForAutomation : styleSheet.htmlNewsletterComposer, ...(styles || []))}  ${className || ''}`}
		>
			{!hideSubject && (
				<div className={css(styleSheet.htmlNewsletterComposerSubjectHeader)}>
					<TextInput
						disabled={readonly}
						inputId={`html-newslettter-composer-subject-${inputGuid}`}
						leftAccessory={label}
						onChange={onChange}
						type='text'
						value={subject || internalSubject || ''}
					/>
					{!readonly && !isIE11() && !isForAutomation && (
						<button
							className={css(
								baseStyleSheet.brandLink,
								baseStyleSheet.horizontalStack,
								styleSheet.htmlNewsletterComposerEditButton
							)}
							onClick={onEditEmailClicked}
						>
							<EditItemPenIcon />
							<span>Edit Email</span>
						</button>
					)}
				</div>
			)}
			<HtmlNewsletterPreview styles={previewerStyles.current} template={template} />
		</div>
	);
};

// eslint-disable-next-line import/no-default-export
export default HtmlNewsletterCampaignComposer;
